"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _Nutzer = _interopRequireDefault(require("../model/Nutzer"));
var _Teilnehmer = _interopRequireDefault(require("../model/Teilnehmer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Teilnehmer service.
* @module api/TeilnehmerApi
* @version 0.0.1
*/
class TeilnehmerApi {
  /**
  * Constructs a new TeilnehmerApi. 
  * @alias module:api/TeilnehmerApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the bookFortbildungGuestTeilnehmerGuestPost operation.
   * @callback module:api/TeilnehmerApi~bookFortbildungGuestTeilnehmerGuestPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Teilnehmer} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Book Fortbildung Guest
   * @param {String} captchaToken 
   * @param {Number} fortbildungId 
   * @param {String} mail 
   * @param {String} vorname 
   * @param {String} nachname 
   * @param {String} telefon 
   * @param {Number} feuerwehrId 
   * @param {module:api/TeilnehmerApi~bookFortbildungGuestTeilnehmerGuestPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Teilnehmer}
   */
  bookFortbildungGuestTeilnehmerGuestPost(captchaToken, fortbildungId, mail, vorname, nachname, telefon, feuerwehrId, callback) {
    let postBody = null;
    // verify the required parameter 'captchaToken' is set
    if (captchaToken === undefined || captchaToken === null) {
      throw new Error("Missing the required parameter 'captchaToken' when calling bookFortbildungGuestTeilnehmerGuestPost");
    }
    // verify the required parameter 'fortbildungId' is set
    if (fortbildungId === undefined || fortbildungId === null) {
      throw new Error("Missing the required parameter 'fortbildungId' when calling bookFortbildungGuestTeilnehmerGuestPost");
    }
    // verify the required parameter 'mail' is set
    if (mail === undefined || mail === null) {
      throw new Error("Missing the required parameter 'mail' when calling bookFortbildungGuestTeilnehmerGuestPost");
    }
    // verify the required parameter 'vorname' is set
    if (vorname === undefined || vorname === null) {
      throw new Error("Missing the required parameter 'vorname' when calling bookFortbildungGuestTeilnehmerGuestPost");
    }
    // verify the required parameter 'nachname' is set
    if (nachname === undefined || nachname === null) {
      throw new Error("Missing the required parameter 'nachname' when calling bookFortbildungGuestTeilnehmerGuestPost");
    }
    // verify the required parameter 'telefon' is set
    if (telefon === undefined || telefon === null) {
      throw new Error("Missing the required parameter 'telefon' when calling bookFortbildungGuestTeilnehmerGuestPost");
    }
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling bookFortbildungGuestTeilnehmerGuestPost");
    }
    let pathParams = {};
    let queryParams = {
      'captchaToken': captchaToken,
      'fortbildung_id': fortbildungId,
      'mail': mail,
      'vorname': vorname,
      'nachname': nachname,
      'telefon': telefon,
      'feuerwehr_id': feuerwehrId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Teilnehmer.default;
    return this.apiClient.callApi('/teilnehmerGuest/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the bookFortbildungTeilnehmerPost operation.
   * @callback module:api/TeilnehmerApi~bookFortbildungTeilnehmerPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Teilnehmer} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Book Fortbildung
   * @param {String} captchaToken 
   * @param {Number} fortbildungId 
   * @param {module:api/TeilnehmerApi~bookFortbildungTeilnehmerPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Teilnehmer}
   */
  bookFortbildungTeilnehmerPost(captchaToken, fortbildungId, callback) {
    let postBody = null;
    // verify the required parameter 'captchaToken' is set
    if (captchaToken === undefined || captchaToken === null) {
      throw new Error("Missing the required parameter 'captchaToken' when calling bookFortbildungTeilnehmerPost");
    }
    // verify the required parameter 'fortbildungId' is set
    if (fortbildungId === undefined || fortbildungId === null) {
      throw new Error("Missing the required parameter 'fortbildungId' when calling bookFortbildungTeilnehmerPost");
    }
    let pathParams = {};
    let queryParams = {
      'captchaToken': captchaToken,
      'fortbildung_id': fortbildungId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _Teilnehmer.default;
    return this.apiClient.callApi('/teilnehmer/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteTeilnehmerTeilnehmerDelete operation.
   * @callback module:api/TeilnehmerApi~deleteTeilnehmerTeilnehmerDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Teilnehmer
   * @param {Number} fortbildungId 
   * @param {module:api/TeilnehmerApi~deleteTeilnehmerTeilnehmerDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteTeilnehmerTeilnehmerDelete(fortbildungId, callback) {
    let postBody = null;
    // verify the required parameter 'fortbildungId' is set
    if (fortbildungId === undefined || fortbildungId === null) {
      throw new Error("Missing the required parameter 'fortbildungId' when calling deleteTeilnehmerTeilnehmerDelete");
    }
    let pathParams = {};
    let queryParams = {
      'fortbildung_id': fortbildungId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/teilnehmer/', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readTeilnehmerTeilnehmerGet operation.
   * @callback module:api/TeilnehmerApi~readTeilnehmerTeilnehmerGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Nutzer>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Teilnehmer
   * @param {Number} fortbildungId 
   * @param {Object} opts Optional parameters
   * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
   * @param {Number} [limit = 100)] Anzahl der Einträge die abgerufen werden sollen.
   * @param {module:api/TeilnehmerApi~readTeilnehmerTeilnehmerGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Nutzer>}
   */
  readTeilnehmerTeilnehmerGet(fortbildungId, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'fortbildungId' is set
    if (fortbildungId === undefined || fortbildungId === null) {
      throw new Error("Missing the required parameter 'fortbildungId' when calling readTeilnehmerTeilnehmerGet");
    }
    let pathParams = {};
    let queryParams = {
      'fortbildung_id': fortbildungId,
      'skip': opts['skip'],
      'limit': opts['limit']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Nutzer.default];
    return this.apiClient.callApi('/teilnehmer/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = TeilnehmerApi;